<template>
  <div class="person">
    <div class="person-title">
      <img src="@/assets/person/dp-gr-sy2.png" class="bg" />
      <img src="@/assets/person/dp-gr-sy1.png" alt class="text" />
      <img src="@/assets/person/dp-gr-sy3.png" alt class="msg" />

      <div class="person-msg">
        <div class="person-first">
          <img :src="headImg | filterB" />
          <span>{{name}}</span>
          <button @click="exitAccount">退出登录</button>
        </div>
        <p class="person-text">{{adress}}</p>
        <div class="icon">
          <div @click="goIntegral">
            <img src="@/assets/person/dp-gr-sy5.png" alt />
            <p>我的积分</p>
          </div>
          <div @click="goStudy">
            <img src="@/assets/person/dp-gr-sy4.png" alt />
            <p>我要学习</p>
          </div>
        </div>
      </div>
    </div>

    <div class="columns" v-for="(column,index) in columns" :key="index">
      <div
        class="column-template"
        v-for="col in columns[index]"
        :key="col.text"
        @click="goColumn(col.text)"
      >
        <div v-if="col.reseauStatus==1?true:false">
          <img :src="col.imgUrl" />
          <span>{{col.text}}</span>
          <img src="@/assets/person/dp-gr-sy12.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baseURL } from '@/utils/baseURL.js'

export default {
  data() {
    return {
      headImg: sessionStorage.getItem("imgheader"),
      name: sessionStorage.getItem("name"),
      adress: sessionStorage.getItem("partybrach"),
      columns: {
        0: [
          {
            imgUrl: require("@/assets/person/dp-gr-sy6.png"),
            text: "个人信息",
            reseauStatus: 1
          },

          {
            imgUrl: require("@/assets/person/dp-gr-sy7.png"),
            text: "我的收藏",
            reseauStatus: 1
          },
          {
            imgUrl: require("@/assets/person/dp-gr-sy8.png"),
            text: "我的足迹",
            reseauStatus: 1
          },
          {
            imgUrl: require("@/assets/person/dp-gr-sy9.png"),
            text: "我要留言",
            reseauStatus: 1
          }
        ],
        1: [
          {
            imgUrl: require("@/assets/person/dp-gr-sy10.png"),
            text: "网格接单员",
            reseauStatus: sessionStorage.getItem("reseauStatus")
          }
          // {
          //   imgUrl: require("@/assets/person/dp-gr-sy11.png"),
          //   text: "聊天室",
          //   reseauStatus: 1
          // }
        ],
        2:[
          {
            imgUrl: require("@/assets/person/dp-gr-fz.png"),
            text: "发展党员活动签到",
            reseauStatus: sessionStorage.getItem('rid')!=0 && sessionStorage.getItem('pmbid')!=0 && sessionStorage.getItem('partybrach')!=''?1:0
          }
        ]
      }
    };
  },
  methods: {
    goStudy() {
      // this.$router.push({ path: "person/study", query: { title: "我要学习" } });
      alert("此功能暂无开放");
    },
    goIntegral() {
      this.$router.push("/person/integral");
    },
    goColumn(text) {
      // console.log(text);
      switch (text) {
        case "个人信息":
          this.$router.push({
            path: "/person/message/message",
            query: { title: "个人信息编辑" }
          });
          break;
        case "我的收藏":
          this.$router.push({
            path: "/person/collect",
            query: { title: "我的收藏" }
          });
          break;
        case "我的足迹":
          this.$router.push({
            path: "/person/footprint",
            query: { title: "我的足迹" }
          });
          break;
        case "我要留言":
          this.$router.push({ path: "/person/leaveboard" });
          break;
        case "网格接单员":
          this.$router.push({
            path: "/person/netBody",
            query: { title: text }
          });
          break;
        case "聊天室":
          this.$router.push({
            path: "/person/linechat",
            query: { title: text }
          });
          //  alert('此功能暂未开放')
          break;
        case "发展党员活动签到":
          this.$router.push({
            path:'/person/createroom',
            query: { title: text }
          })
          break
        default:
          break;
      }
    },
    exitAccount() {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("id");
      sessionStorage.removeItem("roleid");
      sessionStorage.removeItem("status");
      sessionStorage.removeItem("rid");
      sessionStorage.removeItem("township");
      sessionStorage.removeItem("partybrach");
      sessionStorage.removeItem("imgheader");
      sessionStorage.removeItem("mobileid");
      sessionStorage.removeItem("name");
      sessionStorage.removeItem("town");
      sessionStorage.removeItem("reseauStatus");
      sessionStorage.removeItem("pmbid");
      this.$router.push("/login");
    }
  },
  filters: {
    filterB: function(value) {
      // console.log(value);
      if (value != "")
        return value.indexOf("base64") > -1
          ? value
          : `${baseURL}/UserImg/${value}`;
      else {
        return require("@/assets/index/dp-kong.png")
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.person {
  .columns {
    &:nth-child(2) {
      margin-top: 1rem;
    }
    .column-template {
      div {
        img {
          &:nth-child(1) {
            width: 0.28rem;
            height: 0.3rem;
            margin-right: 0.2rem;
          }
          &:nth-child(3) {
            width: 0.15rem;
            height: 0.28rem;
            margin-left: auto;
          }
        }
        width: 94%;
        margin: 0 auto;
        border-bottom: 0.01rem solid #e6e6e6;
        display: flex;
        align-items: center;
      }
    }
    width: 94%;
    margin: 0 auto;
    background: #fff;
    margin-top: 0.5rem;
    line-height: 3;
    box-shadow: 0px 0.06rem 0.06rem 0px rgba(43, 43, 43, 0.06);
  }
  .person-title {
    .person-msg {
      .icon {
        div {
          img {
            width: 0.5rem;
            height: 0.6rem;
          }
          &:nth-child(odd) {
            border-right: 0.01rem solid #eeeeee;
          }
          width: 49%;
        }
        padding: 0.2rem 0;
        font-size: 0.3rem;
        text-align: center;
        display: flex;
      }
      .person-text {
        border-radius: 23px;
        padding: 0.05rem 0.2rem;
        margin-left: 0.2rem;
        width: auto;
        font-size: 0.26rem;
      }
      .person-first {
        span {
          width: 1.5rem;
        }
        img {
          width: 0.8rem;
          height: 0.8rem;
          border-radius: 50%;
          margin-right: 0.2rem;
          vertical-align: middle;
        }
        button {
          border: none;
          padding: 0.1rem 0.2rem;
          color: #fff;
          background: red;
          font-size: 0.28rem;
          border-radius: 0.08rem;
        }
        width: 94%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        padding-bottom: 0.2rem;
        font-size: 0.36rem;
        border-bottom: 0.01rem solid #eeeeee;
      }
      width: 94%;
      margin: 0 auto;
      border-radius: 0.1rem;
      box-shadow: 0px 0.08rem 0.08rem 0px rgba(43, 43, 43, 0.08);
      background-color: #ffffff;
      padding: 0.3rem 0;
      position: absolute;
      bottom: -0.5rem;
      left: 3%;
    }

    .msg {
      position: absolute;
      top: 0.5rem;
      right: 0.3rem;
      width: 0.39rem;
      height: 0.33rem;
    }
    .text {
      position: absolute;
      top: 0.5rem;
      left: 0.2rem;
      width: 2rem;
      height: 0.7rem;
    }
    .bg {
      width: 100%;
    }
    position: relative;
    padding-bottom: 1rem;
  }
  font-size: 0.3rem;
  padding-bottom: 1.5rem;
}
</style>

